import React from 'react';
import './EmployeeDetailModal.scss';

const EmployeeDetailModal = ({ employee, onClose }) => {
  if (!employee) return null;

  return (
    <div className="employee-detail-modal-overlay">
      <div className="employee-detail-modal">
        <div className="modal-header">
          <h2>Employee Details</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        <div className="modal-body">
          <div className="employee-header">
            <div className="employee-avatar">
              {employee.img ? (
                <img src={employee.img} alt={employee.name} />
              ) : (
                <div className="avatar-placeholder">
                  {employee.name?.charAt(0) || 'E'}
                </div>
              )}
            </div>
            <div className="employee-title">
              <h3>{employee.name}</h3>
              <p className="designation">{employee.designation}</p>
              <p className="employee-id">Employee ID: {employee.empID}</p>
            </div>
          </div>
          
          <div className="detail-sections">
            <div className="detail-section">
              <h4>Basic Information</h4>
              <div className="detail-grid">
                <div className="detail-item">
                  <label>Department</label>
                  <p>{employee.organogram || 'Not specified'}</p>
                </div>
                <div className="detail-item">
                  <label>Email</label>
                  <p>{employee.email || 'Not specified'}</p>
                </div>
                <div className="detail-item">
                  <label>Personal Email</label>
                  <p>{employee.personalEmail || 'Not specified'}</p>
                </div>
                <div className="detail-item">
                  <label>Join Date</label>
                  <p>{employee.joinDate || 'Not specified'}</p>
                </div>
                <div className="detail-item">
                  <label>Date of Birth</label>
                  <p>{employee.dob || 'Not specified'}</p>
                </div>
                <div className="detail-item">
                  <label>User Type</label>
                  <p>{employee.userType || 'user'}</p>
                </div>
              </div>
            </div>
            
            <div className="detail-section">
              <h4>Contact Information</h4>
              <div className="detail-grid">
                <div className="detail-item">
                  <label>Phone</label>
                  <p>{employee.phone || 'Not specified'}</p>
                </div>
                <div className="detail-item">
                  <label>WhatsApp</label>
                  <p>{employee.whatsApp || 'Not specified'}</p>
                </div>
                <div className="detail-item">
                  <label>Address</label>
                  <p>{employee.address || 'Not specified'}</p>
                </div>
                <div className="detail-item">
                  <label>Country</label>
                  <p>{employee.country || 'Not specified'}</p>
                </div>
                <div className="detail-item">
                  <label>Location</label>
                  <p>{employee.location || 'Not specified'}</p>
                </div>
              </div>
            </div>
            
            <div className="detail-section">
              <h4>Emergency Contact</h4>
              <div className="detail-grid">
                <div className="detail-item">
                  <label>Name</label>
                  <p>{employee.emergencyContact || 'Not specified'}</p>
                </div>
                <div className="detail-item">
                  <label>Relationship</label>
                  <p>{employee.emergencyRelation || 'Not specified'}</p>
                </div>
                <div className="detail-item">
                  <label>Phone</label>
                  <p>{employee.emergencyNumber || 'Not specified'}</p>
                </div>
              </div>
            </div>
            
            <div className="detail-section">
              <h4>Additional Information</h4>
              <div className="detail-grid">
                <div className="detail-item">
                  <label>Preferred Language</label>
                  <p>{employee.preferredLang || 'English'}</p>
                </div>
                <div className="detail-item">
                  <label>Other Languages</label>
                  <p>{employee.allLang || 'Not specified'}</p>
                </div>
                <div className="detail-item">
                  <label>Leave Entitlement</label>
                  <p>{employee.leaveEntitlement || 21} days</p>
                </div>
                <div className="detail-item">
                  <label>Leave Balance</label>
                  <p>{employee.leaveBalance || 0} days</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="close-button" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default EmployeeDetailModal; 